import { Navbar, Footer } from "@/components/site-chrome";
import { BreccsLanding } from "@/components/landing/breccs-landing";

export function LandingPage() {
  return (
    <div className="min-h-screen" style={{ background: "#F7F5EF", fontFamily: "'Inter', -apple-system, system-ui, sans-serif" }}>
      <Navbar />
      <BreccsLanding />
      <Footer />
    </div>
  );
}

export default LandingPage;
